import axios from "axios";
import router from "@/router";
import rollbar from '@/plugins/rollbar'

export default {
    state: {
        clientInfo: {
            clientCode: null,
            clientPhone: null,
            clientName: null
        }
    },
    mutations: {
        setClientInfo(state, payload) {
            state.clientInfo = payload
        }
    },
    getters: {
        getClientInfo: function(state) {
            return state.clientInfo
        }
    },
    actions: {
        getClientAuthorization({ commit }, payload) {

            if(!payload.clientCode){
                alert('고객코드가 없습니다.')
                return false
            }

            if(!payload.clientPhone){
                alert('패스워드를 입력하세요.')
                return false
            }

            return axios({
                method: 'POST',
                url: this.getters.getApiUrl + '/api/v1/client/clientAuthorization/' + payload.clientCode,
                data: {
                    clientPhone: payload.clientPhone
                },
                timeout: this.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status  == '0000'){

                    const clientInfo = {
                        clientCode: response.data.clientCode,
                        clientPhone: response.data.clientPhone,
                        clientName: response.data.clientName
                    }

                    //로그인 성공 시
                    commit("setClientInfo", clientInfo)

                    if(payload.orderId){
                        //대시보드로 이동
                        router.push('/client/dashboard/' + payload.clientCode + '/' + payload.orderId)
                    }else{
                        //대시보드로 이동
                        router.push('/client/dashboard/' + payload.clientCode)
                    }



                }else{
                    alert(response.data.message)
                    return false
                }

            })
            .catch(() => {

                const clientInfo = {
                    clientCode: null,
                    clientPhone: null,
                    clientClient: null
                }

                //로그인 실패 시
                alert('패스워드를 확인해주세요.')
                commit("setClientInfo", clientInfo)
                rollbar.error('고객 주문확인 인증 실패', payload)

            })

        }
    }
}